import {
  SET_FEEDBACK,
  CLEAR_FEEDBACKS,
} from '../constants/actionTypes';

const initialState = [];

const feedback = (state = initialState, action) => {
  switch (action.type) {
    case SET_FEEDBACK:
      return [...state, action.payload];
    case CLEAR_FEEDBACKS:
      return initialState;
    default:
      return state;
  }
}

export default feedback;



// WEBPACK FOOTER //
// ./src/reducers/reducer-feedback.js